<template>
  <div>
    <a-page-header style="width: 105%; margin-left: -20px" title="">
      <template slot="tags">
        <a-breadcrumb>
          <a-breadcrumb-item href="">
            <a-icon type="rocket"/>
            <span>{{ $t('message.txtManagement.title1') }}</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <a-icon type="book"/>
            <span>{{ $t("message.blackAndWhiteList.blackAndWhiteList") }}</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <a-icon type="book"/>
            <span>{{
                $t("message.blackAndWhiteList.importList")
              }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </template>
    </a-page-header>
    <a-card style="min-height: calc(100vh - 141px);">
      <a-row>
        <a-col :md="{ span: 24 }" :lg="{ span: 8 }" :xl="{ span: 8 }" :xxl="{ span: 8 }">
          <a-form-model
              ref="addFormRef" :model="form" :labelCol="labelCol"
              :wrapperCol="wrapperCol" :rules="rules"
          >
           
            <a-form-model-item :label="$t('message.commonUsage.uploadFile')" prop="file">
              <div class="flex justify-space-between align-items-center w100">
                <a-upload
                    name="file"
                    :multiple="true"
                    action=""
                    :before-upload="beforeUpload"
                    @change="handleChange"
                >
                  <a-button  :size="$globalSize" >
                    <a-icon type="upload"/>
                    {{ $t("message.commonUsage.clickToUpload") }}
                  </a-button>
                </a-upload>
                <a-button  :size="$globalSize"  type="link" @click="downloadTemplate" :loading="downloadTemplateLoading">
                  {{ $t("message.blackAndWhiteList.downloadTemplate") }}
                </a-button>
              </div>
              <div v-if="fileTotal">{{ $t("message.blackAndWhiteList.title10") }}: {{ fileTotal }}</div>
            </a-form-model-item>
            </a-form-model>
            
        </a-col>
      </a-row>
      <a-divider></a-divider>
      <a-row>
        <a-col :md="{ span: 24 }" :lg="{ span: 8 }" :xl="{ span: 8 }" :xxl="{ span: 8 }">
          <div class="flex grid-gap-16 " v-if="!onlyView">
            <a-button  :size="$globalSize"  class="form-submit-btn"  :loading="confirmLoading" @click="submit">{{
                $t('message.commonUsage.save')
              }}
            </a-button>
            <a-button  :size="$globalSize"  class="form-cancel-btn"  @click="$emit('close')">{{
                $t('message.commonUsage.cancel')
              }}
            </a-button>
          </div>

          <div class="flex grid-gap-16 " v-if="onlyView">
            <a-button  :size="$globalSize"  class="form-cancel-btn"  @click="$emit('close')">{{
                $t('message.commonUsage.back')
              }}
            </a-button>
          </div>
        </a-col>
      </a-row>
    </a-card>
    <a-modal
        :title="$t('message.blackAndWhiteList.title12')"
        :visible="visible"
        :closable="false"
        :keyboard="false"
        :maskClosable="false"
        @cancel="handleCancel"
        :footer="null"
        centered
        :bodyStyle="{'padding-left':'24px'}"
    >
      <div v-if="result" class="confirm-modal-body w100 flex flex-direction-column grid-gap-16 justify-content-center align-items-center">
        <div>{{ $t('message.blackAndWhiteList.title14') }}:
          <span>{{ resultData.all_count }}</span>
        </div>
        <div>{{ $t('message.blackAndWhiteList.title15') }}:
          <span>{{ resultData.success_count }}</span>
        </div>
        <div>{{ $t('message.blackAndWhiteList.title16') }}:
          <span>{{ resultData.failed_count }}</span>
        </div>
      </div>
      <div v-else class="confirm-modal-body w100 flex justify-content-center grid-gap-16 flex-direction-column mt24">
        <div>{{  resultMsg  }}
        </div>
      </div>
      <div class="w100 flex justify-content-center grid-gap-16 mt24">
        <a-button  :size="$globalSize"  v-if="result" class="form-submit-btn"  @click="downloadErrorExcel" :loading="downloadErrorLoading">{{
            $t('message.blackAndWhiteList.title11')
          }}
        </a-button>
        <a-button  :size="$globalSize"  v-else class="form-submit-btn"  @click="visible = false">{{
            $t('message.commonUsage.edit')
          }}
        </a-button>
        <a-button  :size="$globalSize"  class="form-cancel-btn"  @click="$emit('close')">{{
            $t('message.commonUsage.back')
          }}
        </a-button>
      </div>
    </a-modal>

  </div>
</template>

<script>
import {formatDate} from "@/utils/formatUtils";
import MyPagination from "@/components/MyPagination";
import blackWhiteService from "@/interface/pages/blackWhiteList";
import moment from "moment";
import {saveFile} from "@/utils/common";

export default {
  name: "importList",
  components: {
    MyPagination
  },
  props: {
    pageType: {
      type: String,
      default: 'add'
    },
    curItem: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    onlyView() {
      return this.pageType === 'view'
    }
  },
  mounted() {

    utils.languageChange(this, {labelCol: 4, wrapperCol: 18}, {labelCol: 6, wrapperCol: 16})
},
  data() {
    let validateFile = (rule, value, callback) => {
      if (this.form.file) {
        callback()
      } else {
        callback(new Error(this.$t('message.commonUsage.uploadFile')))
      }
    }
    return {
      fileTotal: 0,
      result: true,
      resultData: {},
      resultMsg: '',
      visible: false,
      confirmLoading: false,
      loading: false,
      downloadTemplateLoading: false,
      downloadErrorLoading: false,
      form: {
        file: '',
      },
      strategyList: [],
      rules: {
        file: [
          {required: true, message: this.$t('message.commonUsage.uploadFile'), trigger: 'change', validator: validateFile},
        ],
      },
      totalCount: 0,
      spinning: false,
      groupList: [],
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 4 : 8
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 18 : 16
      },
    }
  },
  methods: {
    formatDate,
    submit() {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return false
        this.addList()
      })
    },
    handleCancel(e) {
      this.visible = false;
    },
    async addList() {
      this.confirmLoading = true
      const data = {
        ...this.form,
        userId:localStorage.getItem('userId'),
      }
      delete data.date
      const {data: res} = await blackWhiteService.addByExcel(this, {data})
      if (res.code == 200) {
        this.result = true
        this.resultData = res.data
      } else {
        this.resultMsg = res.message
        this.result = false
      }
      this.visible = true
      this.confirmLoading = false
    },
    async handleChange(info) {
      if(info.file){
        this.loading = true;
        this.form.file = info.file
        await blackWhiteService.uploadFile(this, {
          data: {
            file: info.file,
          },
        }).then(res => {
          if (res.data.code === "200") {
            this.fileTotal = res.data.data;
          } else {
            // this.$message.error(res.data.msg);
          }
        }).finally(() => {
          this.loading = false
        });
      }else{
        this.fileTotal = 0
      }
    },
    beforeUpload(file) {
      return false;
    },

    downloadTemplate() {
      this.downloadTemplateLoading = true
      blackWhiteService.downloadTemplateExcel(this, {}).then(res=>{
        saveFile(res,"UnSubscribe Template.xlsx")
      }).catch((err)=>{
        this.$message.error(err);
      }).finally(()=>{
        this.downloadTemplateLoading = false
      })
    },
     downloadErrorExcel() {
      this.downloadErrorLoading = true
      blackWhiteService.downloadErrorExcel(this, {data:{
        failedValueList:this.resultData.failed_value_list,
        }}).then(res=>{
        saveFile(res,"error report.xlsx")
      }).catch((err)=>{
        this.$message.error(err);
      }).finally(()=>{
        this.downloadErrorLoading = false
      })
    }
  }
}
</script>

<style scoped lang="less">
.confirm-modal-body {
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.9);
}

.add-member-title {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.9);
}

.form-sub-title {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.6);
}


::v-deep .ant-modal-title {
  text-align: left;
}

</style>